/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../assets/error.svg';

import style from './ErrorMessage.module.scss';

const ErrorMessage = ({ message }) => (
  <div className={style.emptyTableContainer}>
    <img src={ErrorIcon} alt="" />
    {message}
    <a
      href="#"
      onClick={() => window.location.reload()}
      className={style.refreshButton}
    >
      Refresh page
    </a>
  </div>
);

export default ErrorMessage;

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

ErrorMessage.defaultProps = {
  message: 'Data could not be loaded',
};
